import { Link, Outlet } from "react-router-dom";

import { useAuth } from "@vellum/micro-app-auth";
import { isPayrollMgmt } from "@/lib/auth/roles";

/** Gates the management views to Region Admin and above. */
export function RequireMgmt() {
  const { user } = useAuth();

  if (!isPayrollMgmt(user)) {
    return (
      <div>
        <h1 className="mb-3 text-2xl font-bold text-green-700">
          Management access required
        </h1>
        <p className="mb-4 max-w-xl text-sm text-gray-600">
          Payroll management is available to region admins and above.
        </p>
        <Link
          to="/"
          className="font-medium text-blue-500 no-underline hover:underline"
        >
          Back to Payroll
        </Link>
      </div>
    );
  }

  return <Outlet />;
}
